import { notFound } from "@tanstack/react-router";
import { createServerFn } from "@tanstack/react-start";
import { siteContext } from "../server/site.server";
import { platformPageResponse } from "./page-response";
import { regularPlanShown } from "./plan-flag.server";
import {
  readAuthorsPage,
  readFeaturePage,
  readGymsPage,
  readLolPage,
  readMembershipAppPage,
  readMonthlyRewardsPage,
  readPricingPage,
} from "./product-pages.server";

/** The League of Legends creators page; null on a creator's site. */
export const loadLolPage = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (!drate.creator) platformPageResponse(drate);
  return readLolPage(drate);
});

/** The membership app page; null on a creator's site. */
export const loadMembershipAppPage = createServerFn({ method: "GET" }).handler(
  async ({ context }) => {
    const drate = await siteContext(context);
    if (!drate.creator) platformPageResponse(drate);
    return readMembershipAppPage(drate, await regularPlanShown(drate));
  },
);

/** The pricing page; null on a creator's site. */
export const loadPricingPage = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (!drate.creator) platformPageResponse(drate);
  return readPricingPage(drate);
});

/** The monthly rewards page, where Instagram's monthly rewards ad lands; null on a creator's site. */
export const loadMonthlyRewardsPage = createServerFn({ method: "GET" }).handler(
  async ({ context }) => {
    const drate = await siteContext(context);
    if (!drate.creator) platformPageResponse(drate);
    return readMonthlyRewardsPage(drate);
  },
);

/** The authors page, where the "Your stories. Your platform. Free." ad lands; null on a creator's site. */
export const loadAuthorsPage = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (!drate.creator) platformPageResponse(drate);
  return readAuthorsPage(drate);
});

/** The gyms page, where the fitness coaches' video ad lands; null on a creator's site. */
export const loadGymsPage = createServerFn({ method: "GET" }).handler(async ({ context }) => {
  const drate = await siteContext(context);
  if (!drate.creator) platformPageResponse(drate);
  return readGymsPage(drate);
});

/** A feature page (/features/<slug>); null on a creator's site or for a feature Drate doesn't have. */
export const loadFeaturePage = createServerFn({ method: "GET" })
  .validator((slug: unknown) => {
    if (typeof slug !== "string" || !/^[a-z-]{1,40}$/.test(slug)) throw notFound();
    return slug;
  })
  .handler(async ({ data: slug, context }) => {
    const drate = await siteContext(context);
    if (!drate.creator) platformPageResponse(drate);
    return readFeaturePage(drate, slug);
  });
